export const settingsItems = [
  {
    id: "profile",
    label: "Profile",
    description: "Account identity and local display preferences.",
    path: "/settings/profile",
    icon: "UserRound",
    order: 1,
  },
  {
    id: "business",
    label: "Business",
    description: "Active vendor organization and access context.",
    path: "/settings/business",
    icon: "Building2",
    order: 2,
  },
  {
    id: "sidebar",
    label: "Sidebar",
    description: "Sidebar, top bar, mobile bar, density, and theme.",
    path: "/settings/sidebar",
    icon: "PanelLeft",
    order: 3,
  },
  {
    id: "modules",
    label: "Modules",
    description: "Choose which installed capabilities appear in navigation.",
    path: "/settings/modules",
    icon: "Blocks",
    order: 4,
  },
  {
    id: "security",
    label: "Security",
    description: "Authentication, App Check, and session controls.",
    path: "/settings/security",
    icon: "ShieldCheck",
    order: 5,
  },
].sort((a, b) => a.order - b.order);

export function getSettingsItems() {
  return settingsItems;
}
